module.exports = __webpack_public_path__ + "img/wild-card-mobile.jpg";